/**
 * Action to close the notes pane.
 *
 * {
 *     type: NOTES_PANE_CLOSE
 * }
 */
export const NOTES_PANE_CLOSE = 'NOTES_PANE_CLOSE';

/**
 * Action to open the notes pane.
 *
 * {
 *     type: NOTES_PANE_OPEN
 * }
 */
export const NOTES_PANE_OPEN = 'NOTES_PANE_OPEN';

/**
 * Action to open the notes modal (native).
 *
 * {
 *     type: OPEN_NOTES_MODAL
 * }
 */
export const OPEN_NOTES_MODAL = 'OPEN_NOTES_MODAL';

/**
 * Action to close the notes modal (native).
 *
 * {
 *     type: CLOSE_NOTES_MODAL
 * }
 */
export const CLOSE_NOTES_MODAL = 'CLOSE_NOTES_MODAL';

/**
 * Native modal identifier for private conference notes.
 */
export const NOTES_MODAL_ID = 'notesModalView';

/**
 * Action to replace the in-memory notes text.
 *
 * {
 *     type: SET_NOTES_TEXT,
 *     text: string
 * }
 */
export const SET_NOTES_TEXT = 'SET_NOTES_TEXT';

/**
 * Action to load notes text from local storage without persisting.
 *
 * {
 *     type: LOAD_CONFERENCE_NOTES,
 *     text: string
 * }
 */
export const LOAD_CONFERENCE_NOTES = 'LOAD_CONFERENCE_NOTES';

/** Updates the result of a local storage write. */
export const NOTES_SAVE_STATUS = 'NOTES_SAVE_STATUS';

/** Flushes pending edits before the browser leaves. */
export const FLUSH_NOTES = 'FLUSH_NOTES';

/**
 * Updates who our notes are shared with and how:
 * { participantIds, audience, permissions, everyonePermission }.
 */
export const SET_NOTES_SHARED_WITH = 'SET_NOTES_SHARED_WITH';

/**
 * Stores notes another participant shared with us:
 * { participantId, text, richText, permission, revision }.
 */
export const SHARED_NOTES_RECEIVED = 'SHARED_NOTES_RECEIVED';

/** Drops notes a participant stopped sharing with us: { participantId }. */
export const SHARED_NOTES_REMOVED = 'SHARED_NOTES_REMOVED';

/** Shows another participant's shared notes, or our own when null: { participantId }. */
export const VIEW_SHARED_NOTES = 'VIEW_SHARED_NOTES';

/**
 * Asks the owner to apply our edit to their shared notes:
 * { participantId, text, richText, revision, requestId }.
 */
export const SHARED_NOTES_EDIT_SUBMIT = 'SHARED_NOTES_EDIT_SUBMIT';

/**
 * Records the owner's verdict on an edit request:
 * { ownerId, requestId, status, revision }.
 */
export const SHARED_NOTES_EDIT_RESULT = 'SHARED_NOTES_EDIT_RESULT';

/**
 * Keeps our local draft of notes another participant shared with edit rights,
 * so it survives pane and tab unmounts:
 * { participantId, text, richText, baseRevision }.
 */
export const SHARED_NOTES_DRAFT_UPDATE = 'SHARED_NOTES_DRAFT_UPDATE';

/**
 * Discards our draft and any resolved request for an owner's shared notes:
 * { participantId }.
 */
export const SHARED_NOTES_DRAFT_CLEAR = 'SHARED_NOTES_DRAFT_CLEAR';
